<template>
  <div>
    <b-row v-if="product != null">
      <b-col cols="12">
        <b-card class="mb-3" title="Ürün Sorusu Güncelle">
          <b-alert variant="warning" show class="mb-0">
            <div class="alert-body mb-2">
              <span
                ><strong>Not:</strong> Güncellenecek ürün sorusu benzersiz
                olmalıdır...</span
              >
            </div>
          </b-alert>
          <b-button
            class="float-right"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            :to="`/product-questions/${id}`"
          >
            Geri Dön
          </b-button>
        </b-card>
      </b-col>
    </b-row>
    <validation-observer ref="rules">
      <b-card class="mb-3" title="Ürün Sorusu Güncelle">
        <b-row>
          <b-col cols="12">
            <div class="text-center">
              <h4>
                Ürün Adı: <b>{{ product.name }}</b>
              </h4>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <div class="text-center">
              <img
                class="img-fluid"
                width="70px"
                :src="product.images.productImage"
                alt="image slot"
              />
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group label="Soru" label-for="question">
              <validation-provider
                #default="{ errors }"
                :rules="{ required: true }"
                name="Soru"
              >
                <v-select
                  id="questions"
                  v-model="selectedQuestion"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="question"
                  :options="questions"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label="Çarpım" label-for="multiplied">
              <validation-provider
                #default="{ errors }"
                :rules="{ required: true }"
                name="Çarpım"
              >
                <b-form-input
                  id="multiplied"
                  v-model="multiplied"
                  placeholder="Çarpım"
                  :state="errors.length > 0 ? false : null"
                  :class="multiplied.length >= chars.multiplied ? 'text-danger' : ''"
                  type="number"
                  inputmode="decimal"
                  step="0.5"
                />
                <small
                  class="textarea-counter-value float-right"
                  :class="multiplied.length >= chars.multiplied ? 'bg-danger' : ''"
                >
                  <span class="char-count">{{ multiplied.length }}</span>
                  /
                  {{ chars.multiplied }}
                </small>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12" class="mt-5">
            <div>
              <b-button
                class="float-right mt-2"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-success"
                @click="postConfirmText(false)"
              >
                <b-spinner v-if="spinner === true && isDraft === false" small />
                {{ spinner === true && isDraft === false ? "Yayınlanıyor" : "Yayınla" }}
              </b-button>
            </div>
          </b-col>
        </b-row>
      </b-card>
    </validation-observer>
  </div>
</template>
<script>
import DragDropImage from "../components/DragDropImage";
import Editor from "../components/Editor";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import { heightTransition } from "@core/mixins/ui/transition";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BImg,
  BRow,
  BCol,
  BTime,
  BCard,
  BCardText,
  BButton,
  BForm,
  BMedia,
  BAlert,
  BSpinner,
  BFormInput,
  BFormGroup,
  BInputGroup,
  BFormTextarea,
  BMediaAside,
  BMediaBody,
  BFormFile,
  BFormDatepicker,
  BFormCheckbox,
  BLink,
} from "bootstrap-vue";
import {
  required,
  email,
  confirmed,
  url,
  between,
  alpha,
  integer,
  password,
  min,
  digits,
  alphaDash,
  length,
} from "@validations";

import { Endpoints } from "@core/endpoints/endpoints";
const endpoints = new Endpoints();

export default {
  components: {
    DragDropImage,
    Editor,
    BImg,
    BRow,
    BCol,
    BTime,
    BLink,
    BCard,
    BCardText,
    BButton,
    BForm,
    BSpinner,
    BAlert,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BFormTextarea,
    BMedia,
    BMediaAside,
    BMediaBody,
    BFormFile,
    BFormDatepicker,
    BFormCheckbox,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    required,
    email,
    confirmed,
    url,
    between,
    alpha,
    integer,
    password,
    min,
    digits,
    alphaDash,
    length,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      id: this.$route.params.idParam,
      product: null,
      productQuestion: {},
      questions: [],
      multiplied: 10,
      isDraft: false,
      spinner: false,
      chars: {
        multiplied: 3,
      },
    };
  },
  watch: {},
  methods: {
    getQuestions() {
      endpoints
        .getQuestions(null, this.$i18n.locale, () => {})
        .then((data) => {
          this.questions = [...data.response];
          this.selectedQuestion = this.questions[0];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getProductById() {
      endpoints
        .getProductById(this.id, this.$i18n.locale, () => {})
        .then((data) => {
          this.product = data.response;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    postConfirmText(isDraft) {
      this.isDraft = isDraft;
      this.$swal({
        title: "Kayıt?",
        text: "Ürün sorusunu güncellemek istediğinize emin misiniz?",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Vazgeç!",
        confirmButtonText: "Kaydet!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.postSubmit();
        }
      });
    },
    postSubmit() {
      this.$refs.rules.validate().then((success) => {
        if (success) {
          this.spinner = true;
          let formData = new FormData();
          formData.append("productId", this.id);
          formData.append("questionId", this.selectedQuestion.id);
          formData.append("multiplied", this.multiplied);

          endpoints
            .postProductQuestion(formData, this.$i18n.locale, () => {})
            .then((data) => {
              this.spinner = false;
              if (data.status) {
                this.$swal({
                  icon: "success",
                  title: "Kayıt başarılı!",
                  text: "Ürün Sorusu Güncellendi.",
                  customClass: {
                    confirmButton: "btn btn-success",
                  },
                }).then((result) => {
                  if (result.value) {
                    this.$router.push({
                      path: `/product-questions/${this.id}`,
                    });
                  }
                });
              } else {
                this.$swal({
                  title: "Hata!",
                  text: "Ürün sorusu benzersiz değil!",
                  icon: "error",
                  confirmButtonText: "Tamam",
                  customClass: {
                    confirmButton: "btn btn-primary",
                  },
                }).then((result) => {
                  if (result.value) {
                  }
                });
              }
            })
            .catch((err) => {
              this.spinner = false;
              console.log(err);
            });
        }
      });
    },
  },
  created() {},
  destroyed() {},
  mounted() {
    this.getQuestions();
    this.getProductById();
  },
  setup() {},
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
